<template>
    <svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9376 0L0 10.5L10.9376 21L13 19.0201L4.12482 10.5L13 1.9799L10.9376 0Z" fill="#007AFF"/>
    </svg>
</template>

<script>
    export default {
        name: "Back"
    }
</script>

<style scoped>

</style>